import React from 'react';
import {useTranslator} from '../../lib/hooks/useTranslator.js';
import {Button, Icon} from 'semantic-ui-react';

export const RefreshButton = ({...props}) => {
    const [t] = useTranslator('common');
    return (
        <Button type={'button'} primary {...props}>
            {t('words.reloadPage')}
            <Icon className={'right'} name={'redo'}/>
        </Button>
    );
};

